import { useConfig } from 'config';
import type { FC } from 'react';

import BannerGroupSliders from 'components/BannerSlider';
import SeoText from 'components/SeoText';

const SportsBookPage: FC = () => {
  const config = useConfig('config.siteConfig.sportsbook.banner');
  const bannerGroupName = config?.group;

  return (
    <div>
      <h1>Sportsbook page</h1>
      {bannerGroupName && (
        <BannerGroupSliders groupName={bannerGroupName} delay={config?.delay} />
      )}
      <SeoText />
    </div>
  );
};

export default SportsBookPage;
